import { getType } from 'typesafe-actions'
import * as actions from './actions'
import {
  StoreState,
  DashboardAction,
  DashboardData,
  TypeOfTask,
  Filter,
} from './types'
import produce from 'immer'
import parseErrorMessage from 'utils/parseErrorMessage'
import { sortingList } from 'utils/helper'
import { sortingActivityList } from '../../seemoreQc/function'
import { cloneDeep } from 'lodash'

const initData = {
  TotalToDo: 0,
  ToDo: [],
  TotalInProgress: 0,
  InProgress: [],
  TotalQCChecking: 0,
  QCChecking: [],
  TotalFixFromQC: 0,
  FixFromQC: [],
} as DashboardData

const initFilter = {
  FloorList: [],
  ZoneList: [],
  WbsList: [],
  LeafWbsList: [],
} as Filter

const initialState: StoreState = {
  data: initData,
  originalData: initData,
  event: {
    IsLoading: false,
    MessageSuccess: '',
    SubmitError: '',
    SubmitSuccess: false,
    SubmitType: '',
  },
  sorting: {
    todo: 'asc',
    inProgress: 'asc',
    qcChecking: 'asc',
    fixFromQC: 'asc',
  },
  query: {
    date: {
      start: undefined,
      end: undefined,
    },
  },
  filter: cloneDeep(initFilter),
}

const sortingColumn = {
  todo: 'TaskRatio',
  inProgress: 'NumOfFail',
  qcChecking: 'RequestDate',
  fixFromQC: 'LastUpdatedDate',
}

export default function(
  state: StoreState = initialState,
  action: DashboardAction
): StoreState {
  return produce(state, draft => {
    switch (action.type) {
      case getType(actions.getZoneDashbaordAction.request):
        draft.event.SubmitError = undefined
        draft.event.IsLoading = true
        draft.event.SubmitSuccess = false
        draft.data = state.data
        break
      case getType(actions.getZoneDashbaordAction.success):
        draft.event.IsLoading = false
        const response = action.payload.ResponseData
        const sorting = state.sorting

        const todoSort = sortingActivityList(
          response.ToDo,
          sorting.todo,
          sortingColumn.todo
        )

        const cmInProgressSort = sortingList(
          response.InProgress,
          sorting.cmInProgress,
          sortingColumn.inProgress,
          'number'
        )

        const qcInProgressSort = sortingList(
          response.QCChecking,
          sorting.qcInProgress,
          sortingColumn.qcChecking,
          'date'
        )

        const fixFromQCSort = sortingList(
          response.FixFromQC,
          sorting.fixFromQC,
          sortingColumn.fixFromQC,
          'date'
        )

        draft.data = {
          ToDo: todoSort,
          InProgress: cmInProgressSort,
          QCChecking: qcInProgressSort,
          FixFromQC: fixFromQCSort,
          TotalToDo: response.TotalToDo,
          TotalInProgress: response.TotalInProgress,
          TotalQCChecking: response.TotalQCChecking,
          TotalFixFromQC: response.TotalFixFromQC,
        }

        draft.originalData = {
          ToDo: response.ToDo,
          InProgress: response.InProgress,
          QCChecking: response.QCChecking,
          FixFromQC: response.FixFromQC,
          TotalToDo: response.TotalToDo,
          TotalInProgress: response.TotalInProgress,
          TotalQCChecking: response.TotalQCChecking,
          TotalFixFromQC: response.TotalFixFromQC,
        }

        break
      case getType(actions.getZoneDashbaordAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)

        break

      case getType(actions.sortingDashboard):
        let typ: string = action.payload
        let orderBy: string = state.sorting[typ]
        orderBy = orderBy !== 'asc' ? 'asc' : 'desc'
        draft.sorting[typ] = orderBy

        if (typ === TypeOfTask.TODO) {
          const list = sortingActivityList(
            state.data.ToDo,
            orderBy,
            sortingColumn.todo
          )

          draft.data.ToDo = list
        } else if (typ === TypeOfTask.InProgress) {
          const list = sortingList(
            state.data.InProgress,
            orderBy,
            sortingColumn.inProgress,
            'number'
          )

          draft.data.InProgress = list
        } else if (typ === TypeOfTask.QCChecking) {
          const list = sortingList(
            state.data.QCChecking,
            orderBy,
            sortingColumn.qcChecking,
            'date'
          )

          draft.data.QCChecking = list
        } else if (typ === TypeOfTask.FixFromQC) {
          const list = sortingList(
            state.data.FixFromQC,
            orderBy,
            sortingColumn.fixFromQC,
            'date'
          )

          draft.data.FixFromQC = list
        }
        break
      case getType(actions.updateFilter):
        draft.filter = { ...action.payload }
        break
      case getType(actions.clearFilter):
        draft.filter = cloneDeep(initFilter)
        break

      default:
        return state
    }
  })
}
